<template>
  <div class="school-courses-list-view">
    <div class="content">
      <!-- 左侧分类侧边栏 -->
      <CategorySidebar
        :category-tree="categoryTree"
        :classify-id="null"
        @select="(val) => toCoursesWithClassify(val.id, val.name)"
      />

      <div class="rightBox">
        <!-- 多重级联分类 + 模式筛选卡片 -->
        <div class="mode-filter-card">
          <!-- 一级分类行 (可折叠) -->
          <div
            class="filter-row"
            :class="{ 'collapsed-row': !isCategoryExpanded }"
          >
            <div class="filter-label">板块:</div>
            <div class="filter-options-wrap">
              <div class="filter-options" ref="categoryOptions">
                <div
                  class="filter-option"
                  :class="{ active: searchForm.firstLevelClassifyId === '' }"
                  @click="handleParentClassifyChange('')"
                >
                  全部
                </div>
                <div
                  class="filter-option"
                  v-for="cat in categoryTree"
                  :key="cat.id"
                  :class="{
                    active: searchForm.firstLevelClassifyId === cat.id,
                  }"
                  @click="handleParentClassifyChange(cat)"
                >
                  {{ cat.name }}
                </div>
              </div>
            </div>
            <!-- 展开/收起按钮 -->
            <div
              class="expand-toggle-btn"
              v-show="showExpandButton"
              @click="isCategoryExpanded = !isCategoryExpanded"
            >
              <span>{{ isCategoryExpanded ? "收起" : "展开" }}</span>
              <i
                :class="
                  isCategoryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                "
              ></i>
            </div>
          </div>

          <!-- 二级子分类行 (联动) -->
          <div
            class="filter-row secondary-filter-row"
            :class="{ 'collapsed-row': !isSubCategoryExpanded }"
            v-if="activeSecondaryCategories.length"
          >
            <div class="filter-label">目录:</div>
            <div class="filter-options-wrap">
              <div class="filter-options" ref="subCategoryOptions">
                <div
                  class="filter-option"
                  :class="{ active: searchForm.secondLevelClassifyId === '' }"
                  @click="handleSubClassifyChange('')"
                >
                  全部
                </div>
                <div
                  class="filter-option"
                  v-for="child in activeSecondaryCategories"
                  :key="child.id"
                  :class="{
                    active: searchForm.secondLevelClassifyId === child.id,
                  }"
                  @click="handleSubClassifyChange(child)"
                >
                  {{ child.name }}
                </div>
              </div>
            </div>
            <!-- 展开/收起按钮 -->
            <div
              class="expand-toggle-btn"
              v-show="showSubExpandButton"
              @click="isSubCategoryExpanded = !isSubCategoryExpanded"
            >
              <span>{{ isSubCategoryExpanded ? "收起" : "展开" }}</span>
              <i
                :class="
                  isSubCategoryExpanded
                    ? 'el-icon-arrow-up'
                    : 'el-icon-arrow-down'
                "
              ></i>
            </div>
          </div>

          <!-- 三级细分类行 (联动) -->
          <div
            class="filter-row secondary-filter-row"
            :class="{ 'collapsed-row': !isThirdCategoryExpanded }"
            v-if="activeThirdCategories.length"
          >
            <div class="filter-label">三级分类:</div>
            <div class="filter-options-wrap">
              <div class="filter-options" ref="thirdCategoryOptions">
                <div
                  class="filter-option"
                  :class="{ active: searchForm.thirdLevelClassifyId === '' }"
                  @click="handleThirdClassifyChange('')"
                >
                  全部
                </div>
                <div
                  class="filter-option"
                  v-for="third in activeThirdCategories"
                  :key="third.id"
                  :class="{
                    active: searchForm.thirdLevelClassifyId === third.id,
                  }"
                  @click="handleThirdClassifyChange(third)"
                >
                  {{ third.name }}
                </div>
              </div>
            </div>
            <!-- 展开/收起按钮 -->
            <div
              class="expand-toggle-btn"
              v-show="showThirdExpandButton"
              @click="isThirdCategoryExpanded = !isThirdCategoryExpanded"
            >
              <span>{{ isThirdCategoryExpanded ? "收起" : "展开" }}</span>
              <i
                :class="
                  isThirdCategoryExpanded
                    ? 'el-icon-arrow-up'
                    : 'el-icon-arrow-down'
                "
              ></i>
            </div>
          </div>

          <!-- 模式筛选行 -->
          <div class="filter-row">
            <div class="filter-label">模式:</div>
            <div class="filter-options-wrap">
              <div class="filter-options">
                <div
                  class="filter-option"
                  :class="{ active: tabAct == -1 }"
                  @click="tabChange(-1)"
                >
                  全部
                </div>
                <div
                  class="filter-option"
                  v-for="(item, index) in headTabList"
                  :key="index"
                  :class="{ active: tabAct == index }"
                  @click="tabChange(index)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 排序栏：发布日期/浏览人数 与 检索输入框 -->
        <div class="sort-bar">
          <div class="sort-left">
            <div
              class="sort-item"
              :class="{ active: searchForm.sortField === 'createTime' }"
              @click="toggleSort('createTime')"
            >
              <span>发布日期</span>
              <span class="sort-arrows">
                <i
                  class="el-icon-caret-top"
                  :class="{
                    active:
                      searchForm.sortField === 'createTime' &&
                      searchForm.sortOrder === 'asc',
                  }"
                ></i>
                <i
                  class="el-icon-caret-bottom"
                  :class="{
                    active:
                      searchForm.sortField === 'createTime' &&
                      searchForm.sortOrder === 'desc',
                  }"
                ></i>
              </span>
            </div>
            <div
              class="sort-item"
              :class="{ active: searchForm.sortField === 'viewCount' }"
              @click="toggleSort('viewCount')"
            >
              <span>浏览人数</span>
              <span class="sort-arrows">
                <i
                  class="el-icon-caret-top"
                  :class="{
                    active:
                      searchForm.sortField === 'viewCount' &&
                      searchForm.sortOrder === 'asc',
                  }"
                ></i>
                <i
                  class="el-icon-caret-bottom"
                  :class="{
                    active:
                      searchForm.sortField === 'viewCount' &&
                      searchForm.sortOrder === 'desc',
                  }"
                ></i>
              </span>
            </div>
          </div>

          <!-- 右侧模糊检索框 -->
          <div class="sort-search">
            <input
              type="text"
              placeholder="搜索当前分类下的课程..."
              v-model="searchForm.title"
              @keyup.enter="handleLocalSearch"
            />
            <i
              class="el-icon-search search-icon"
              @click="handleLocalSearch"
            ></i>
          </div>
        </div>

        <div class="listWrap">
          <!-- 加载动画 -->
          <SchoolLoading :visible="listLoading" />

          <template v-if="list.length">
            <div class="card-grid">
              <!-- 课程卡片子组件 -->
              <CourseCard
                v-for="(item, index) in list"
                :key="index"
                :item="item"
                :back-ground="backGround"
                :color-enum="colorEnum"
                @click="toDetails"
              />
            </div>

            <div class="page">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pages.total"
                :page-size="pages.size"
                :current-page="pages.page"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </template>
          <None v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategorySidebar from "./CategorySidebar.vue";
import CourseCard from "./CourseCard.vue";
import { courseInfoList } from "@/api/lx";
import SchoolLoading from "./SchoolLoading.vue";

export default {
  name: "CoursesView",
  components: {
    CategorySidebar,
    CourseCard,
    SchoolLoading,
  },
  props: {
    // 课程分类树形数据
    categoryTree: {
      type: Array,
      default: () => [],
    },
    // 筛选模式列表（即授权权益等级）
    headTabList: {
      type: Array,
      default: () => [],
    },
    // 卡片背景色枚举
    backGround: {
      type: Object,
      default: () => ({}),
    },
    // 卡片字体颜色枚举
    colorEnum: {
      type: Object,
      default: () => ({}),
    },
    // 初始路由或者外部传入的分类ID
    initialClassifyId: {
      type: [String, Number],
      default: "",
    },
    // 外部传入的全局搜索词
    globalSearchVal: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      listLoading: false,
      listRequestId: 0,
      minLoadingTime: 500,
      pages: {
        page: 1,
        total: 0,
        size: 12,
      },
      classifyId: this.initialClassifyId,
      classifyName: "全部",
      tabAct: -1,
      isCategoryExpanded: false,
      showExpandButton: false,
      isSubCategoryExpanded: false,
      showSubExpandButton: false,
      isThirdCategoryExpanded: false,
      showThirdExpandButton: false,
      searchForm: {
        title: this.globalSearchVal,
        firstLevelClassifyId: "",
        secondLevelClassifyId: "",
        thirdLevelClassifyId: "",
        equityClassName: "",
        sortField: "",
        sortOrder: "desc",
      },
    };
  },
  computed: {
    /**
     * 获取当前选中一级分类下的所有二级分类子项
     * @returns {Array} 二级分类列表
     */
    activeSecondaryCategories() {
      if (!this.searchForm.firstLevelClassifyId) return [];
      const parent = this.categoryTree.find(
        (c) => c.id === this.searchForm.firstLevelClassifyId
      );
      return parent && parent.children ? parent.children : [];
    },
    /**
     * 获取当前选中二级分类下的所有三级分类细项
     * @returns {Array} 三级分类列表
     */
    activeThirdCategories() {
      if (
        !this.searchForm.firstLevelClassifyId ||
        !this.searchForm.secondLevelClassifyId
      )
        return [];
      const parent = this.categoryTree.find(
        (c) => c.id === this.searchForm.firstLevelClassifyId
      );
      if (!parent || !parent.children) return [];
      const second = parent.children.find(
        (c) => c.id === this.searchForm.secondLevelClassifyId
      );
      return second && second.children ? second.children : [];
    },
  },
  watch: {
    categoryTree: {
      immediate: true,
      handler() {
        this.checkCategoryOverflow();
        this.syncInitialClassify();
      },
    },
    initialClassifyId(newVal) {
      if (newVal !== this.classifyId) {
        this.toCoursesWithClassify(newVal);
      }
    },
    globalSearchVal(newVal) {
      this.searchForm.title = newVal;
      this.pages.page = 1;
      this.getList();
    },
    isCategoryExpanded() {
      this.checkCategoryOverflow();
    },
    isSubCategoryExpanded() {
      this.checkCategoryOverflow();
    },
    isThirdCategoryExpanded() {
      this.checkCategoryOverflow();
    },
    activeSecondaryCategories() {
      this.checkCategoryOverflow();
    },
    activeThirdCategories() {
      this.checkCategoryOverflow();
    },
  },
  created() {
    this.getList();
  },
  mounted() {
    window.addEventListener("resize", this.checkCategoryOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkCategoryOverflow);
  },
  methods: {
    /**
     * 依据外部传入的 initialClassifyId 补全高亮层级关系
     * @returns {void}
     */
    syncInitialClassify() {
      if (
        this.classifyId &&
        this.categoryTree.length &&
        !this.searchForm.firstLevelClassifyId
      ) {
        this.toCoursesWithClassify(this.classifyId);
      }
    },
    /**
     * 拉取并刷新分页课程数据列表
     * @returns {void}
     */
    getList() {
      const requestId = ++this.listRequestId;
      const startTime = Date.now();
      this.listLoading = true;

      courseInfoList({
        page: this.pages.page,
        size: this.pages.size,
        ...this.searchForm,
      })
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          this.list = res.data.records || [];
          this.pages.total = res.data.total || 0;
        })
        .finally(() => {
          if (requestId !== this.listRequestId) return;
          const remain = this.minLoadingTime - (Date.now() - startTime);
          const delay = remain > 0 ? remain : 0;
          setTimeout(() => {
            if (requestId !== this.listRequestId) return;
            this.listLoading = false;
          }, delay);
        });
    },
    /**
     * 页码变化事件
     * @param {number} val - 目的页码
     * @returns {void}
     */
    currentChange(val) {
      this.pages.page = val;
      this.getList();
    },
    /**
     * 模式（等级分类）切换事件
     * @param {number|string} val - 选中的模式索引或固定标识，若为 -1 则为全部，若为 'liangxin' 则为良信
     * @returns {void}
     */
    tabChange(val) {
      if (this.tabAct === val) return;
      this.pages.page = 1;
      this.tabAct = val;
      if (val === -1) {
        this.searchForm.equityClassName = "";
      } else if (val === "liangxin") {
        this.searchForm.equityClassName = "良信";
      } else {
        this.searchForm.equityClassName = this.headTabList[val]
          ? this.headTabList[val].name
          : "";
      }
      this.getList();
    },
    /**
     * 选中并联动定位一二三级分类高亮
     * @param {string|number} id - 分类ID
     * @param {string} [name=""] - 分类名称
     * @returns {void}
     */
    toCoursesWithClassify(id, name = "") {
      this.pages.page = 1;
      this.classifyId = id;

      if (!id) {
        this.searchForm.firstLevelClassifyId = "";
        this.searchForm.secondLevelClassifyId = "";
        this.searchForm.thirdLevelClassifyId = "";
        this.classifyName = "全部";
      } else {
        let foundParent = null;
        let foundSecond = null;
        let foundThird = null;

        for (const cat of this.categoryTree) {
          if (cat.id === id) {
            foundParent = cat;
            break;
          }
          if (cat.children && cat.children.length) {
            for (const second of cat.children) {
              if (second.id === id) {
                foundParent = cat;
                foundSecond = second;
                break;
              }
              if (second.children && second.children.length) {
                const third = second.children.find((c) => c.id === id);
                if (third) {
                  foundParent = cat;
                  foundSecond = second;
                  foundThird = third;
                  break;
                }
              }
            }
          }
          if (foundParent) break;
        }

        if (foundThird) {
          this.searchForm.firstLevelClassifyId = foundParent.id;
          this.searchForm.secondLevelClassifyId = foundSecond.id;
          this.searchForm.thirdLevelClassifyId = id;
          this.classifyName = name || foundThird.name;
        } else if (foundSecond) {
          this.searchForm.firstLevelClassifyId = foundParent.id;
          this.searchForm.secondLevelClassifyId = id;
          this.searchForm.thirdLevelClassifyId = "";
          this.classifyName = name || foundSecond.name;
        } else if (foundParent) {
          this.searchForm.firstLevelClassifyId = id;
          this.searchForm.secondLevelClassifyId = "";
          this.searchForm.thirdLevelClassifyId = "";
          this.classifyName = name || foundParent.name;
        } else {
          this.searchForm.firstLevelClassifyId = "";
          this.searchForm.secondLevelClassifyId = "";
          this.searchForm.thirdLevelClassifyId = "";
          this.classifyName = name || "全部";
        }
      }
      this.getList();
    },
    /**
     * 切换一级分类选项并触发过滤
     * @param {Object|string} cat - 选中的一级分类对象，若为 '全部' 则传空字符串
     * @returns {void}
     */
    handleParentClassifyChange(cat) {
      this.pages.page = 1;
      this.isSubCategoryExpanded = false;
      this.isThirdCategoryExpanded = false;
      if (cat === "") {
        this.searchForm.firstLevelClassifyId = "";
        this.searchForm.secondLevelClassifyId = "";
        this.searchForm.thirdLevelClassifyId = "";
        this.classifyName = "全部";
      } else {
        this.searchForm.firstLevelClassifyId = cat.id;
        this.searchForm.secondLevelClassifyId = "";
        this.searchForm.thirdLevelClassifyId = "";
        this.classifyName = cat.name;
      }
      this.getList();
    },
    /**
     * 切换二级子分类选项并触发过滤
     * @param {Object|string} child - 选中的二级分类对象，若为 '全部' 则传空字符串
     * @returns {void}
     */
    handleSubClassifyChange(child) {
      this.pages.page = 1;
      this.isThirdCategoryExpanded = false;
      if (child === "") {
        this.searchForm.secondLevelClassifyId = "";
        this.searchForm.thirdLevelClassifyId = "";
        const parent = this.categoryTree.find(
          (c) => c.id === this.searchForm.firstLevelClassifyId
        );
        this.classifyName = parent ? parent.name : "全部";
      } else {
        this.searchForm.secondLevelClassifyId = child.id;
        this.searchForm.thirdLevelClassifyId = "";
        this.classifyName = child.name;
      }
      this.getList();
    },
    /**
     * 切换三级细分类选项并触发过滤
     * @param {Object|string} third - 选中的三级分类对象，若为 '全部' 则传空字符串
     * @returns {void}
     */
    handleThirdClassifyChange(third) {
      this.pages.page = 1;
      if (third === "") {
        this.searchForm.thirdLevelClassifyId = "";
        const parent = this.categoryTree.find(
          (c) => c.id === this.searchForm.firstLevelClassifyId
        );
        if (parent && parent.children) {
          const second = parent.children.find(
            (s) => s.id === this.searchForm.secondLevelClassifyId
          );
          this.classifyName = second
            ? second.name
            : parent
            ? parent.name
            : "全部";
        } else {
          this.classifyName = parent ? parent.name : "全部";
        }
      } else {
        this.searchForm.thirdLevelClassifyId = third.id;
        this.classifyName = third.name;
      }
      this.getList();
    },
    /**
     * 切换当前列表的排序字段和排序顺序（发布时间 / 浏览人数）
     * @param {string} field - 排序字段，可选值为 'createTime' (发布时间) 或 'viewCount' (浏览人数)
     * @returns {void}
     */
    toggleSort(field) {
      this.pages.page = 1;

      if (this.searchForm.sortField === field) {
        if (this.searchForm.sortOrder === "desc") {
          // 当前是降序 -> 切换为升序
          this.searchForm.sortOrder = "asc";
        } else if (this.searchForm.sortOrder === "asc") {
          // 当前是升序 -> 切换为空（不排序）
          this.searchForm.sortField = "";
          this.searchForm.sortOrder = "";
        }
      } else {
        // 点击不同的排序字段 -> 默认为第一态（降序）
        this.searchForm.sortField = field;
        this.searchForm.sortOrder = "desc";
      }

      this.getList();
    },

    /**
     * 查看课程详情
     * @param {Object} item - 课程元数据
     * @returns {void}
     */
    toDetails(item) {
      if (!item.canView) {
        this.$message.warning("抱歉，当前课程暂无权限学习");
        return;
      }
      this.$router.push({
        path: "/school/details",
        query: {
          id: item.id,
          classifyName: this.classifyName || "全部",
          classifyId: this.classifyId,
        },
      });
    },
    /**
     * 当前列表内的本地模糊搜索
     * @returns {void}
     */
    handleLocalSearch() {
      this.pages.page = 1;
      this.getList();
    },
    /**
     * 检测分类选项的容器是否超出一行，从而动态显示/隐藏展开收起按钮
     * @returns {void}
     */
    checkCategoryOverflow() {
      this.$nextTick(() => {
        // 1. 一级分类溢出检测
        const el = this.$refs.categoryOptions;
        this.showExpandButton = el ? el.scrollHeight > 36 : false;

        // 2. 二级分类溢出检测
        const subEl = this.$refs.subCategoryOptions;
        this.showSubExpandButton = subEl ? subEl.scrollHeight > 36 : false;

        // 3. 三级分类溢出检测
        const thirdEl = this.$refs.thirdCategoryOptions;
        this.showThirdExpandButton = thirdEl
          ? thirdEl.scrollHeight > 36
          : false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.school-courses-list-view {
  width: 100%;
  box-sizing: border-box;
}

.content {
  width: 100%;
  display: flex;
  margin-top: 0px;
  box-sizing: border-box;
}

.rightBox {
  width: 100%;
  margin-top: 0px;
  box-sizing: border-box;
}
.listWrap {
  min-height: 400px;
  position: relative;
}

.page {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 55px;
}

/* 多重级联分类 + 模式筛选样式 */
.mode-filter-card {
  width: 100%;
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  backdrop-filter: blur(2px);
  box-sizing: border-box;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  position: relative;

  &.collapsed-row {
    .filter-options {
      max-height: 36px;
      overflow: hidden;
    }
  }
}

.secondary-filter-row {
  padding-top: 12px;
  border-top: 1px dashed rgba(186, 202, 198, 0.2);
}

.filter-label {
  width: 80px;
  font-size: 14px;

  font-weight: 700;
  line-height: 32px;
  color: #3b4a47;
  flex-shrink: 0;
}

.filter-options-wrap {
  flex: 1;
  overflow: hidden;
  margin-right: 80px;
}

.filter-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  transition: max-height 0.3s ease;
}

.filter-option {
  padding: 6px 16px;

  font-size: 14px;

  font-weight: 400;
  line-height: 20px;
  color: #3b4a47;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;

  &:hover {
    background: rgba(186, 202, 198, 0.1);
    color: #00d8c3;
  }

  &.active {
    background: rgba(0, 216, 195, 0.1);
    color: rgb(0, 216, 195);
    font-weight: 600;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  }
}

.expand-toggle-btn {
  position: absolute;
  right: 0;
  top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #6b7a77;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  transition: color 0.3s;

  &:hover {
    color: #00d8c3;
  }

  i {
    font-size: 12px;
  }
}

/* 排序工具栏样式 */
.sort-bar {
  width: 100%;
  padding-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
  border-bottom: 1px solid rgba(186, 202, 198, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.sort-left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.sort-search {
  position: relative;
  width: 240px;
  height: 34px;
  background: #f6f3f2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding-right: 12px;
  border: 1px solid transparent;
  transition: border-color 0.3s, background-color 0.3s;

  &:focus-within {
    border-color: #00d8c3;
    background: #ffffff;
  }

  input {
    flex: 1;
    border: none;
    background: transparent;
    padding: 0 12px;
    height: 100%;
    outline: none;
    font-size: 13px;
    color: #3b4a47;

    &::placeholder {
      color: #9baaa6;
    }
  }

  .search-icon {
    font-size: 16px;
    color: #6b7a77;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #00d8c3;
    }
  }
}

.sort-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;

  font-weight: 500;
  line-height: 20px;
  color: #3b4a47;
  cursor: pointer;
  user-select: none;
  transition: color 0.3s;
  &:hover {
    color: #00d8c3;
  }
  &.active {
    color: #00d8c3;
    font-weight: 700;
  }
  .sort-arrows {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
    height: 14px;
    line-height: 7px;
    i {
      color: #bacac6;
      transition: color 0.3s;
      &.active {
        color: #00d8c3;
      }
    }
  }
}

/* 课程卡片网格 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 10px;
}
</style>
